// 主演阵容档案（演示性策划内容）
export const actors = [
  {
    id: "cha-seoyeon",
    name: "车瑞妍",
    roman: "Cha Seo-yeon",
    age: "28 岁",
    agency: "青丘娱乐",
    height: "168cm",
    debut: "2016 年",
    roleTag: "浪漫爱情剧女主",
    avatar:
      "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20young%20East%20Asian%20actress%20with%20long%20soft%20wavy%20hair%2C%20calm%20confident%20expression%2C%20warm%20cream%20beige%20studio%20backdrop%2C%20soft%20window%20light%2C%20muted%20coral%20accent%2C%20high%20end%20magazine%20photography%2C%20natural%20makeup%2C%20clean%20composition&width=500&height=500&seq=hd-actor-01&orientation=squarish",
    bio: "以一部青春校园剧出道，凭《首尔月台》里的车站广播员一角跻身一线。擅长把克制的情感演出层次，被观众称为「眼泪开关」。",
    works: "《首尔月台》《济州岛的雪》《如果那天》",
    facts: ["出道前是大学广播站台长", "拍《首尔月台》时自学了手语", "最想演反派"],
  },
  {
    id: "lee-dohun",
    name: "李道勋",
    roman: "Lee Do-hun",
    age: "33 岁",
    agency: "白杨影业",
    height: "184cm",
    debut: "2011 年",
    roleTag: "演技派男主",
    avatar:
      "https://readdy.ai/api/search-image?query=Refined%20editorial%20portrait%20of%20an%20East%20Asian%20male%20actor%20in%20his%20early%20thirties%20with%20neat%20dark%20hair%20and%20a%20thoughtful%20gaze%2C%20wearing%20a%20soft%20knit%20sweater%2C%20warm%20cream%20studio%20background%2C%20gentle%20side%20lighting%2C%20muted%20amber%20tone%2C%20premium%20magazine%20photography%2C%20clean%20minimal%20composition&width=500&height=500&seq=hd-actor-02&orientation=squarish",
    bio: "话剧舞台出身，转战荧幕后以「剧抛脸」著称。从医生、司机到财阀私生子，每个角色都让人认不出上一部作品里的他。",
    works: "《首尔月台》《济州岛的雪》《无名之城》",
    facts: ["有着十年话剧演出经历", "为角色减重 12 公斤", "业余爱好是木工"],
  },
  {
    id: "kim-moyeon",
    name: "金慕妍",
    roman: "Kim Mo-yeon",
    age: "31 岁",
    agency: "青丘娱乐",
    height: "172cm",
    debut: "2013 年",
    roleTag: "收视保障",
    avatar:
      "https://readdy.ai/api/search-image?query=Poised%20editorial%20portrait%20of%20an%20elegant%20East%20Asian%20actress%20in%20her%20thirties%20with%20shoulder%20length%20sleek%20hair%20and%20a%20warm%20assured%20smile%2C%20wearing%20a%20cream%20blazer%2C%20soft%20beige%20studio%20backdrop%2C%20diffused%20lighting%2C%20subtle%20terracotta%20tones%2C%20luxury%20magazine%20photography%2C%20clean%20composition&width=500&height=500&seq=hd-actor-03&orientation=squarish",
    bio: "出道近十年几乎没有失手作品，被剧迷称为「收视保障」。在《四季食堂》和《汉江以北》中展现了截然不同的两面。",
    works: "《四季食堂》《汉江以北》《玫瑰公寓》",
    facts: ["拥有饮食节目主持经验", "会在片场给后辈做饭", "爱收藏黑胶唱片"],
  },
  {
    id: "jung-woobin",
    name: "郑宇彬",
    roman: "Jung Woo-bin",
    age: "39 岁",
    agency: "白杨影业",
    height: "181cm",
    debut: "2006 年",
    roleTag: "实力派前辈",
    avatar:
      "https://readdy.ai/api/search-image?query=Distinguished%20editorial%20portrait%20of%20an%20East%20Asian%20male%20actor%20in%20his%20late%20thirties%20with%20a%20calm%20mature%20expression%20and%20salt%20and%20pepper%20hair%2C%20wearing%20a%20dark%20turtleneck%2C%20warm%20grey%20studio%20backdrop%2C%20cinematic%20lighting%2C%20muted%20brown%20tones%2C%20prestige%20magazine%20photography%2C%20clean%20composition&width=500&height=500&seq=hd-actor-04&orientation=squarish",
    bio: "电影圈常客，近年回归小荧幕。无论是《汉江以北》里的退休刑警，还是《黄金帝国》里的财阀家长，都能演出被岁月磨过的重量。",
    works: "《汉江以北》《黄金帝国》《冬夜列车》",
    facts: ["两度获得电影节最佳男配", "在片场指导新人从不收费", "喜欢钓鱼"],
  },
  {
    id: "seo-hajun",
    name: "徐河准",
    roman: "Seo Ha-jun",
    age: "29 岁",
    agency: "月影娱乐",
    height: "186cm",
    debut: "2017 年",
    roleTag: "上升期小生",
    avatar:
      "https://readdy.ai/api/search-image?query=Fresh%20editorial%20portrait%20of%20a%20young%20East%20Asian%20male%20actor%20in%20his%20late%20twenties%20with%20soft%20dark%20hair%20and%20a%20bright%20open%20expression%2C%20wearing%20a%20cream%20shirt%2C%20warm%20ivory%20studio%20background%2C%20soft%20even%20lighting%2C%20muted%20sand%20tones%2C%20lifestyle%20magazine%20photography%2C%20clean%20minimal%20composition&width=500&height=500&seq=hd-actor-05&orientation=squarish",
    bio: "从配角一步步磨到今天，被观众记住是因为《九号病房》里那个笨拙却认真的住院医。越战越稳，是公认的潜力股。",
    works: "《九号病房》《首尔月台》《青春会客厅》",
    facts: ["身高是剧组梗担当", "篮球爱好者", "台词功底受导演称赞"],
  },
  {
    id: "bae-seojun",
    name: "裴书俊",
    roman: "Bae Seo-jun",
    age: "35 岁",
    agency: "白杨影业",
    height: "170cm",
    debut: "2010 年",
    roleTag: "百变配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20portrait%20of%20an%20East%20Asian%20actress%20in%20her%20mid%20thirties%20with%20short%20neat%20hair%20and%20a%20sincere%20determined%20expression%2C%20wearing%20a%20structured%20grey%20jacket%2C%20soft%20taupe%20studio%20backdrop%2C%20natural%20lighting%2C%20muted%20dusty%20tones%2C%20quality%20magazine%20photography%2C%20clean%20composition&width=500&height=500&seq=hd-actor-06&orientation=squarish",
    bio: "既能演检察官也能演护理组长，是剧组最爱的那类「放到哪都稳」的演员。近年凭借《汉江以北》申睿恩一角被更多观众认识。",
    works: "《汉江以北》《九号病房》《长夜将尽》",
    facts: ["戏剧专业教师出身", "擅长方言", "出演过三十余部作品"],
  },
  {
    id: "oh-selin",
    name: "吴世琳",
    roman: "Oh Se-rin",
    age: "27 岁",
    agency: "月影娱乐",
    height: "165cm",
    debut: "2019 年",
    roleTag: "甜系女配",
    avatar:
      "https://readdy.ai/api/search-image?query=Sweet%20editorial%20portrait%20of%20a%20young%20East%20Asian%20actress%20in%20her%20mid%20twenties%20with%20a%20short%20bob%20and%20a%20cheerful%20smile%2C%20wearing%20a%20soft%20rose%20cardigan%2C%20warm%20peach%20studio%20backdrop%2C%20bright%20soft%20lighting%2C%20muted%20coral%20tones%2C%20friendly%20lifestyle%20photography%2C%20clean%20composition&width=500&height=500&seq=hd-actor-07&orientation=squarish",
    bio: "以综艺出道，转型演戏后凭「讨喜女配」圈粉。《首尔月台》里嘴硬心软的同事敏贞，被观众称为全剧最想拥有的闺蜜。",
    works: "《首尔月台》《黄金帝国》《今天也晴朗》",
    facts: ["综艺感极强", "会三种乐器", "养了两只猫"],
  },
  {
    id: "kang-taeyun",
    name: "姜泰允",
    roman: "Kang Tae-yun",
    age: "30 岁",
    agency: "青丘娱乐",
    height: "182cm",
    debut: "2015 年",
    roleTag: "亦正亦邪",
    avatar:
      "https://readdy.ai/api/search-image?query=Striking%20editorial%20portrait%20of%20an%20East%20Asian%20male%20actor%20in%20his%20early%20thirties%20with%20sharp%20features%20and%20slicked%20back%20hair%2C%20wearing%20a%20dark%20charcoal%20coat%2C%20moody%20warm%20grey%20studio%20backdrop%2C%20dramatic%20side%20lighting%2C%20muted%20amber%20highlights%2C%20cinematic%20magazine%20photography%2C%20clean%20composition&width=500&height=500&seq=hd-actor-08&orientation=squarish",
    bio: "天生的「反派脸」，但《黄金帝国》之后观众发现他演起深情来同样致命。是导演们心中亦正亦邪的首选。",
    works: "《黄金帝国》《汉江以北》",
    facts: ["武术功底扎实", "喜欢研究剧本到凌晨", "收藏复古手表"],
  },
];